import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    activeColor: String,
    highlight: String
  }

  connect() {
    this.colorAttribute = this.element.dataset.tabsActiveColor
    this.darkAttribute = this.element.dataset.tabsHighlight
    console.log("Color attribute:", this.colorAttribute)
    console.log("dark attribute:", this.colorAttribute)
    this.activate(0)
  }

  activate(index) {
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.remove("border-transparent", "text-gray-500", "hover:border-gray-300", "hover:text-gray-700")
        const color = this.colorAttribute.replace(/[\[\]]/g, '')

        if (this.darkAttribute === '#2A2A2A') {
          tab.style.borderBottomColor = color
          tab.style.color = this.darkAttribute
        } else {
          tab.style.borderBottomColor = color
          tab.style.color = color
        }
      } else {
        tab.style.borderBottomColor = ""
        tab.style.color = ""
        tab.classList.add("border-transparent", "text-gray-500", "hover:border-gray-300", "hover:text-gray-700")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }

  switch(event) {
    const clickedTab = event.currentTarget
    const index = this.tabTargets.indexOf(clickedTab)
    this.activate(index)
  }
}
